import { useEffect } from 'react';

const useScrollReveal = (selector: string = '.goleft') => {
    useEffect(() => {
        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('active');
                    observer.unobserve(entry.target);
                }
            });
        }, {
            rootMargin: '0px 0px -100px 0px', // Adjusted offset slightly
            threshold: 0.1
        });

        const elements = document.querySelectorAll(selector);
        elements.forEach((el) => observer.observe(el));

        return () => {
            elements.forEach((el) => observer.unobserve(el));
        };
    }, [selector]);
};

export default useScrollReveal;
